import React, { useState, useEffect } from 'react';
import { apiClient } from '../services/api';
import './CatalogProgress.css';

function pluralize(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n);
  const mod10 = abs % 10;
  const mod100 = abs % 100;
  if (mod100 >= 11 && mod100 <= 19) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}

export const CatalogProgress: React.FC = () => {
  const [salesCount, setSalesCount] = useState(0);
  const [activeTotalValue, setActiveTotalValue] = useState(0);
  const [goalAmount, setGoalAmount] = useState<number | null>(null);

  useEffect(() => {
    const loadProgress = async () => {
      try {
        const progress = await apiClient.getMyProgress();
        setSalesCount(progress.sales_count);
        setActiveTotalValue(progress.active_total_value);
        setGoalAmount(progress.goal);
      } catch {
        // ignore
      }
    };
    loadProgress();
  }, []);

  const progressPercent =
    goalAmount != null && goalAmount > 0 ? Math.min((activeTotalValue / goalAmount) * 100, 100) : 0;

  return (
    <div className="catalog-progress-section">
      <div className="progress-top-row">
        <span className="progress-top-label">Моя доля рынка ху#ков</span>
        <span className="progress-sales-chip">
          {salesCount} {pluralize(salesCount, 'продажа', 'продажи', 'продаж')}
        </span>
      </div>
      <div className="progress-amount-row">
        <span className="progress-amount-current">{activeTotalValue.toLocaleString('ru-RU')}&thinsp;&#8381;</span>
        <span className="progress-amount-total">
          / {goalAmount != null ? goalAmount.toLocaleString('ru-RU') : '—'}&thinsp;&#8381;
        </span>
      </div>
      <div className="progress-bar-container">
        <div className="progress-bar-horizontal">
          <div className="progress-bar-fill" style={{ width: `${progressPercent}%` }} />
        </div>
      </div>
    </div>
  );
};
